<template>
  <div class="spa-reservation-info">
    <div class="container">
      <h2 class="spa-reservation-info__title">
        {{ reservationDetailsData.propertyData.facilityName }}
      </h2>

      <div
        class="spa-reservation-info__details"
      >
        <div
          v-if="reservationDetailsData.confirmationCode"
          class="spa-reservation-info__detail"
        >
          <span class="spa-reservation-info__label">
            {{ tc('spaSoft.reservationdetails.confirmationCodeLabel') }}
          </span>
          <span class="spa-reservation-info__value">
            {{ reservationDetailsData.confirmationCode }}
          </span>
        </div>

        <div class="spa-reservation-info__detail">
          <span class="spa-reservation-info__label">
            {{ tc('spaSoft.reservationdetails.date') }}
          </span>
          <span class="spa-reservation-info__value">{{ dateFormatted }}</span>
        </div>

        <div class="spa-reservation-info__detail">
          <span class="spa-reservation-info__label">
            {{ tc('spaSoft.reservationdetails.time') }}
          </span>
          <span class="spa-reservation-info__value">{{ timeRangeFormatted }}</span>
        </div>

        <button
          class="spa-reservation-info__property-btn"
          :class="{ 'is-active': isPropertyDetailsOpen }"
          @click="togglePropertyDetails"
        >
          {{ tc('spaSoft.reservationdetails.propertyDetailsCta') }}
        </button>
      </div>
      <transition name="expand-y">
        <div
          v-if="isPropertyDetailsOpen"
          class="spa-reservation-info__property-details"
        >
          <div class="spa-reservation-info__contact">
            <p
              v-if="reservationDetailsData.propertyData.address"
              class="spa-reservation-info__address"
            >
              {{ reservationDetailsData.propertyData.address }}
              {{ reservationDetailsData.propertyData.city ? ',' : '' }}
            </p>
            <p
              v-if="reservationDetailsData.propertyData.city"
              class="spa-reservation-info__city"
            >
              {{ reservationDetailsData.propertyData.city }}
            </p>

            <a
              v-if="reservationDetailsData.propertyData.phone"
              :href="`tel:${reservationDetailsData.propertyData.phone}`"
              class="spa-reservation-info__phone"
            >
              <span class="icon-phone-white" />
              {{ reservationDetailsData.propertyData.phone }}
            </a>

            <a
              v-if="reservationDetailsData.propertyData.email"
              :href="`mailto:${reservationDetailsData.propertyData.email}`"
              class="spa-reservation-info__email"
            >
              <span class="icon-envelope-white" />
              {{ reservationDetailsData.propertyData.email }}
            </a>
          </div>

          <div class="spa-reservation-info__map">
            <div class="map-frame map property google-map component">
              <google-map
                :properties="[
                  {
                    'Title': reservationDetailsData.propertyData.facilityName,
                    'Latitude': reservationDetailsData.propertyData.latitude,
                    'Longitude': reservationDetailsData.propertyData.longitude,
                    'Description': reservationDetailsData.propertyData.description,
                    'Link': `https://www.google.com/maps/search/?api=1&query=${reservationDetailsData.propertyData.latitude},${reservationDetailsData.propertyData.longitude}`,
                    'Image': reservationDetailsData.propertyData.imageSrc,
                  }
                ]"
                :options="{
                  'ApiKey': mapOptions.ApiKey,
                  'Latitude': reservationDetailsData.propertyData.latitude,
                  'Longitude': reservationDetailsData.propertyData.longitude,
                  'CtaButtonTitle': mapOptions.CtaButtonTitle,
                  'ZoomLevel': mapOptions.ZoomLevel,
                  'MapType': mapOptions.MapType,
                  'MapId': mapOptions.MapId,
                  'MarkerColor': mapOptions.MarkerColor
                }"
              />
            </div>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
  import { mapState, mapGetters } from 'vuex'
  import { formatDateZone } from '@utils/date-helpers'

  export default {
    name: 'SpaReservationInfo',
    inject: ['mapOptions'],
    data() {
      return {
        isPropertyDetailsOpen: false
      }
    },
    computed: {
      ...mapState('spaSoft', ['reservationDetailsData']),
      ...mapGetters('spaSoft', ['getTimeslotTimeRange']),
      ...mapGetters('i18n', ['tc']),
      dateFormatted() {
        return this.reservationDetailsData?.date ? formatDateZone(this.reservationDetailsData?.date, null, 'dddd, DD MMMM, YYYY') : ''
      },
      timeRangeFormatted() {
        return this.getTimeslotTimeRange(this.reservationDetailsData?.guestAvailabilities)
      }
    },
    methods: {
      togglePropertyDetails() {
        this.isPropertyDetailsOpen = !this.isPropertyDetailsOpen
      }
    }
  }
</script>
